import { getApiBaseUrl } from "./configHelper";

const api = {
  // --- Generic GET ---
  get: async (endpoint, params = {}) => {
    const baseUrl = await getApiBaseUrl();
    const url = new URL(`${baseUrl}/${endpoint}`);

    Object.keys(params).forEach((key) => url.searchParams.append(key, params[key]));

    const response = await fetch(url.toString());
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    const json = await response.json();
    return json;
  },

 post: async (endpoint, body = {}, extraParams = {}) => {
    const baseUrl = await getApiBaseUrl();
    const url = new URL(`${baseUrl}/${endpoint}`);

    Object.keys(extraParams).forEach((key) => url.searchParams.append(key, extraParams[key]));

    const response = await fetch(url.toString(), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return response.json();
  },

  
  AdmincheckLogin: (payload) => api.post("AdminCheckLogin", payload),   
  GetMenulist: (user, ItemType, Menudate) => api.get("GetMenulist", { user, ItemType, Menudate }),
  GetPreviousMenuListAPI: (Username, ActionDate) => api.get("GetPreviousMenuListAPI", { Username, ActionDate }),
  InsertPreviousMenuListAPI: (payload) => api.post("InsertPreviousMenuListAPI", payload),
  SaveMenuListAPI: (payload) => api.post("SaveMenuListAPI", payload), 
  RateUpdateAPI: (user, ItemId, Circle1Rate, Circle2Rate, Circle3Rate, ItemDesc = "-", Menudate, TakeAway = 0) =>
          api.get("RateUpdateAPI", { user, ItemId, Circle1Rate, Circle2Rate, Circle3Rate, ItemDesc, Menudate, TakeAway }),
  DeleteOrderItemAPI: (ItemId, Menudate) => api.get("DeleteOrderItemAPI", { ItemId, Menudate }),
  GetDashboardListAPI: (user) => api.get("GetDashboardListAPI", { user }),
  GetOnlineItemList: (OId) => api.get("GetOnlineItemList", { OId }),
  GetCustomerList: (Vid, UserType) => api.get("GetCustomerList", { Vid, UserType }),
  VerifyCustomerAPI: (payload) => api.post("VerifyCustomerAPI", payload),
  GetAreaList: ( ) => api.get("GetAreaList", {  }),
  GetAreaListCircleWiseAPI: (Username) => api.get("GetAreaListCircleWiseAPI", { Username }),
  GetSavedAreaLockListAPI: (Username) => api.get("GetSavedAreaLockListAPI", { Username }),
  UpdateRainDisabledAreasAPI: (payload) => api.post("UpdateRainDisabledAreasAPI", payload),
  UpdateDistributionListAPI: (payload) => api.post("UpdateDistributionListAPI", payload),
  GetOrderDetails: (User) => api.get("GetOrderDetails", { User }),
  ConfirmOrders: (OId,User) => api.get("ConfirmOrders", { OId,User }),
  GetCustomerPayment: (User) => api.get("GetCustomerPayment", { User }),
  PaymentApproval: (OId) => api.get("PaymentApproval", { OId }),
  OnlineNewCustomers: (user) => api.get("OnlineNewCustomers", { user }),
  OnlineCustomerVerification: (payload) => api.post("OnlineCustomerVerification", payload),

  GetOrderTime: (Username) => api.get("GetOrderTime", { Username }),
  UpdateOrderTime: (id,breakfast, lunch,dinner,other) => api.get("UpdateOrderTime", { id,breakfast, lunch,dinner,other }),
  OnlineOrderSummary: (ActionDate) => api.get("OnlineOrderSummary", { ActionDate }),
  OnlineOrderItemSummary: (ActionDate, Itemid) => api.get("OnlineOrderItemSummary", { ActionDate, Itemid}),
  GetOrderDetailsRev: (User, isconfirmed) => api.get("GetOrderDetailsRev", { User, isconfirmed }),
 
  //OrderForm
  GenFdOrdvaluesAPI: (User, Sessid) => api.get("GenFdOrdvaluesAPI", { User, Sessid }),
  GetItemvaluesAPI: (vid, User, itemtype, Vcode) => api.get("GetItemvaluesAPI", { vid, User, itemtype, Vcode }),
  GetpackTypevaluesAPI: (Itemid, Qty, User) => api.get("GetpackTypevaluesAPI", { Itemid, Qty, User }),
  FdOrderSaveAPI: (payload) => api.post("FdOrderSaveAPI", payload),
  EditFdOrderlistAPI: (PrimeIdStr) => api.get("EditFdOrderlistAPI", { PrimeIdStr }),
  //ReceiptUpload
  GpaylogAPI: (payload) => api.post("GpaylogAPI", payload),
  SaveGpaylogAPI: (payload) => api.post("SaveGpaylog", payload),
  GetUpiPaymentListAPI: (payload) => api.post("GetUpiPaymentListAPI", payload),
  SaveUPIPaymentAPI: (payload) => api.post("SaveUPIPaymentAPI", payload),

  //DeliverySheet
  DeliverySheetItemAPI: (User) => api.get("DeliverySheetItemAPI", { User }),
  GetBillCollectionAPI: (Dhid) => api.get("GetBillCollectionAPI", { Dhid }),
  GetDeliveryItemAPI: (User, ItemType, Actiondate) => api.get("GetDeliveryItemAPI", { User, ItemType, Actiondate }),
  AllotDeliveryPersonAPI: (payload) => api.post("AllotDeliveryPersonAPI", payload),
  //DeliveryUpdate
  DeliverySheetUpdateItemAPI: (User) => api.get("DeliverySheetUpdateItemAPI", { User }),
  DeliveryUpdateItemAPI: (User, ItemType, Actiondate) => api.get("DeliveryUpdateItemAPI", { User, ItemType, Actiondate }),
  DeliveryBillCollectionAPI: (payload) => api.post("DeliveryBillCollectionAPI", payload),
  DeliveryReceiptBillUpdateAPI: (payload) => api.post("DeliveryReceiptBillUpdateAPI", payload),
  UpdateDheadAPI: (payload) => api.post("UpdateDheadAPI", payload),

//OrderProcess
 GetOrderProcessAPI: (User, SesId) => api.get("GetOrderProcessAPI", { User, SesId }),
OrderProcessAPI: (AsOnDate, ItemType, SesId, User) =>  api.get("OrderProcessAPI", { AsOnDate, ItemType, SesId, User }),
 DeleteSimpleOrderAPI: (poId, actionDate, itemtype) => api.get("DeleteSimpleOrderAPI", { poId, actionDate, itemtype }),
 UPdateOrderRowFdsAPI: (UPdateOrderRowFds) => api.post("UpdateOrderRowFdsAPI", UPdateOrderRowFds),
 SaveOrderProcessAPI: (SaveOrderProcess) => api.post("SaveOrderProcessAPI", SaveOrderProcess),    
  SimplePotoInvoiceAPI: (SimplePotoInvoice) => api.post("SimplePotoInvoiceAPI", SimplePotoInvoice),

  //CustomerMaster
    GetGenFdGenvaluesAPI: (User, Sessid) => api.get("GetGenFdGenvaluesAPI", { User, Sessid }),
 GetPaymentCycleAPI: (PaymentCycle) => api.get("GetPaymentCycleAPI", { PaymentCycle }),
  EditFdCustomerlist: (PrimeIdStr) => api.get("EditFdCustomerlist", { PrimeIdStr }),
  FdCustomreSaveAPI: (payload) => api.post("FdCustomreSaveAPI", payload),
  CustomerListExplrAPI: (User) => api.get("CustomerListExplrAPI", { User }),
  CustomerAddAPI: (payload) => api.post("CustomerAddAPI", payload),

  //OrderandPayment
  GetOrderSummary: (FromDate, ToDate) => api.get("GetOrderSummary", { FromDate, ToDate }),
  GetOrderItem: (Oid) => api.get("GetOrderItem", { Oid }),
    GetOrderRatingsFeedback: (user) => api.get("GetOrderRatingsFeedback", { user }),
};
// ✅ Upload file(s)
api.UploadAttachment = async (formData) => {
  const baseUrl = await getApiBaseUrl();
  const url = `${baseUrl}/api/UploadAttachment`;

  const response = await fetch(url, {
    method: "POST",
    body: formData, 
  });

  if (!response.ok) throw new Error(`Upload failed! ${response.status}`);
  return response.json();
};

// ✅ Get attachments for a record
api.GetAttachments = async (MdlId, PrimeId) => {
  const baseUrl = await getApiBaseUrl();
  const url = new URL(`${baseUrl}/api/GetAttachments`);
  url.searchParams.append("mdlId", MdlId);
  url.searchParams.append("primeId", PrimeId);

  const response = await fetch(url);
  if (!response.ok) throw new Error(`Failed to fetch attachments`);
  return response.json();
};

// ✅ Delete attachment by ID
api.DeleteAttachment = async (id) => {
  const baseUrl = await getApiBaseUrl();
  const url = new URL(`${baseUrl}/api/DeleteAttachment`);
  url.searchParams.append("id", id);

  const response = await fetch(url, { method: "DELETE" });
  if (!response.ok) throw new Error("Failed to delete attachment");
  return response.json();
};

export default api;
